import { FC } from 'react';

import AchForm from 'components/ach-form';
import ACHHeader from 'components/ach-header';
import AdyenACHForm from 'components/adyen-ach-form';
import { useAppSelector } from 'hooks';
import { effectiveACHType } from 'modules/payment-methods';
import { ACH_ADD, ACH_ADD_PAY, PAYMENT_METHODS_TYPES } from 'utils/constants';

interface AchAddProps {
  intent: typeof ACH_ADD | typeof ACH_ADD_PAY;
}

const AchAdd: FC<AchAddProps> = ({ intent }): JSX.Element => {
  const selectedACHType = useAppSelector(effectiveACHType);

  return (
    <>
      <ACHHeader />
      {selectedACHType === PAYMENT_METHODS_TYPES.achAdyen ? <AdyenACHForm intent={intent} /> : <AchForm />}
    </>
  );
};

export default AchAdd;
